<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png"  class="bgImg"/>
      <img src="../../../static/images/index/session.png" class="sessionImg"/>
      <div class="tb_right">
        <p>中国·广州</p>
        <p>中国进出口商品交易会展馆</p>
      </div>
    </div>
    <div class="exhinfo-box">
      <div class="exhImg" v-if="info">
        <van-image
          fit="contain"
          :src="info.HeadlineLogo"
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
        />
      </div>
      <div class="chiName">{{ info.CompanyName }}</div>
      <div class="enName">{{ info.CompanyNameEng }}</div>

      <div class="location">
        <span v-if="info.HallNo && info.PlaceNo"
          >{{ info.HallNo }}馆 {{ info.PlaceNo }}</span
        >
        <img src="../../../static/images/index/position.png" />
      </div>
      <div
        class="openingBtn"
        v-if="info.CMemberId > 0 || info.InterMemberID > 0"
        @click.stop="toVisitRoom(info.CMemberId, info.InterDomain)"
      >
        参观该企业网上展厅
      </div>
    </div>
    <div class="exh_title">产品领域</div>
    <div class="exh_describe">{{ info.Product }}</div>
    <div class="exh_title">工厂地址</div>
    <div class="exh_describe">
      <div>{{ info.AddressChi }}</div>
      <div>{{ info.AddressEng }}</div>
    </div>
  </div>
</template>
<script>
import { Image } from "vant";
import { visitShareInfo } from "@/api/index";
export default {
  name: "expoExhibitorDetail",
  components: {
    "van-image": Image,
  },
  data() {
    return {
      info: "",
    };
  },
  methods: {
    toVisitRoom(mid, domain) {
      if (mid) {
        this.$router.push({ path: "/storeShow", query: { mid: mid } });
      } else if (domain) {
        window.location.href = "https://m.lightstrade.com/storeShow/" + domain;
      } else {
      }
    },
    getInfo() {
      visitShareInfo({ StoreId: this.$route.query.sid }).then((res) => {
        this.info = res.Data;
      });
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
<style lang="less" scoped>
.container {
  .top-box {
    width: 375px;
    height: 170px;
    position: relative;

    .bgImg {
      width: 100%;
      height: 100%;
    }

    .sessionImg {
        position: absolute;
        z-index: 2;
        top: 70px;
        left: 30px;
        width: 180px;
    }

    .tb_right {
      position: absolute;
      z-index: 2;
      left: auto;
      right: 10px;
      bottom: 10px;
      font-size: 10px;
      text-align: right;
      color: #fff;
    }
  }
  .exhinfo-box {
    position: relative;
    padding: 65px 0 20px 0;
    .exhImg {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.17);
      border-radius: 3px;
      /deep/.van-image {
        display: block;
        width: 80px;
        height: 80px;
      }
      /deep/.van-icon__image {
        display: block;
        width: 80px;
        height: 80px;
      }
    }
    .chiName {
      width: 300px;
      font-size: 20px;
      line-height: 21px;
      font-weight: bold;
      color: #333333;
      margin: 0 auto;
      text-align: center;
      line-height: 28px;
    }
    .enName {
      font-size: 10px;
      line-height: 12px;
      color: #333333;
      text-align: center;
      margin-top: 7px;
    }
    .location {
      position: relative;
      margin-top: 22px;
      span {
        position: absolute;
        z-index: 2;
        top: 9px;
        left: 50%;
        transform: translate(-50%, 0);
        color: #333;
        font-size: 18px;
      }
      img {
        width: 100%;
        vertical-align: top;
      }
    }
    .openingBtn {
      margin: 22px auto 0;
      width: 200px;
      height: 45px;
      text-align: center;
      line-height: 44px;
      box-sizing: border-box;
      border-radius: 6px;
      background: #d62f2f;
      border: 1px solid #d62f2f;
      color: #fff;
      font-size: 15px;
    }
  }
  .exh_title {
    font-size: 12px;
    line-height: 13px;
    color: #7b8294;
    position: relative;
    margin: 30px 15px 0 15px;
    padding-left: 14px;
  }
  .exh_title::before {
    display: block;
    content: "";
    position: absolute;
    z-index: 2;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    width: 7px;
    height: 15px;
    background: #7b8294;
    border-radius: 4px;
  }
  .exh_describe {
    color: #333;
    font-size: 11px;
    padding: 0 15px;
    margin-top: 12px;
    margin-bottom: 15px;
  }
}
</style>
